const OVERVIEW_URL =
  'https://ckan.opendata.swiss/api/3/action/package_show?id=echtzeitdaten-am-abstimmungstag-zu-eidgenoessischen-abstimmungsvorlagen';

export const getOpendataOverview = async () => {
  const response = await fetch(OVERVIEW_URL);
  const data = await response.json();
  return data;
};

export const getOpendataPollDay = async (url: string) => {
  if (!url) return null;
  const response = await fetch(url);
  const data = await response.json();
  return data;
};
